import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import star from '../assets/wallet_download_page/blue_star.png';
import download from '../assets/wallet_download_page/download.png';
import playstore from '../assets/wallet_download_page/playstore.png';
import shield from '../assets/wallet_download_page/shield.png';
import verified from '../assets/wallet_download_page/verified_tick.png';
import logo from '../assets/wallet_download_page/glip_logo.png';

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 96vh;
  }
`;


const GradientButton = styled.div`
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 31px;
`;

const GreyButton = styled.a`
    background: #1C1F33;
    border-radius: 8px;
    padding: 12px;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const BlueButton = styled.a`
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    border-radius: 8px;
    padding: 12px;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 125%;
    text-align: center;
    letter-spacing: 0.1px;
    color: #FFFFFF;
`;

const Card = styled.div`
    background: rgba(38, 40, 62, 0.4);
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 3px;
    width: 100%;
`;

const CardTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 9px;
    margin-bottom: 6px;
`;

const CardText = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    color: #7A7F9E;
`;


export default function DownloadConnectWallet(props) {    
    const location = useLocation();
    const queryParam = new URLSearchParams(location.search).get('deeplink');
    const link = `glipwallet://open_url?url=${encodeURIComponent(queryParam)}`;

    console.log('generated link ============================> @nox check here', link)
    
    return (
        <>
        <Mobile>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '100%',
            }}>
                <div style={{                    
                    background: 'linear-gradient(180deg, #2844B2 0%, rgba(115, 35, 221, 0) 100%)',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: '0 16px',
                    paddingTop: 100,
                }}>
                    <img src={logo} style={{width: '100px', height: '100px'}} />
                    <div style={{display: 'flex', marginTop: 58}}>
                        <Title>Glip Wallet</Title>
                        <img src={verified} style={{marginLeft: '10px'}}/>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '50px', width: '100%'}}>
                        <Card>
                            <img src={star} style={{width: 20, height: 20}}/>
                            <CardTitle>4.4</CardTitle>
                            <CardText>60k Ratings</CardText>
                        </Card>
                        <Card>
                            <img src={download} style={{width: 20, height: 20}}/>
                            <CardTitle>6M</CardTitle>
                            <CardText>Downloads</CardText>
                        </Card>
                    </div>
                </div>
                <div style={{padding: '0 16px', width: '100%'}}>
                    <GreyButton href={link}>
                        Open Glip Wallet (if installed)
                    </GreyButton>
                    <BlueButton style={{marginTop: 12}} href={'https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US&utm_source=LOK'}>
                        <img src={playstore} style={{width: 20, height: 20, marginRight: 10}}/>
                        <div>Download Glip Wallet</div>
                        <img src={shield} style={{width: 20, height: 20, marginLeft: 10}}/>
                    </BlueButton>
                </div>
            </div>
        </Mobile>       
        <Desktop style={{}}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '100%',
            }}>
                <div style={{                    
                    background: 'linear-gradient(180deg, #2844B2 0%, rgba(115, 35, 221, 0) 100%)',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: '0 16px',
                    paddingTop: 100,
                }}>
                    <img src={logo} style={{width: '100px', height: '100px'}} />
                    <div style={{display: 'flex', marginTop: 58}}>
                        <Title>Glip Wallet</Title>
                        <img src={verified} style={{marginLeft: '10px'}}/>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '50px', width: '100%'}}>
                        <Card>
                            <img src={star} style={{width: 20, height: 20}}/>
                            <CardTitle>4.4</CardTitle>
                            <CardText>60k Ratings</CardText>
                        </Card>
                        <Card>
                            <img src={download} style={{width: 20, height: 20}}/>
                            <CardTitle>6M</CardTitle>
                            <CardText>Downloads</CardText>
                        </Card>
                    </div>
                </div>
                <div style={{padding: '0 16px', width: '100%'}}>
                    <GreyButton href={link}>
                        Open Glip Wallet (if installed)
                    </GreyButton>
                    <BlueButton style={{marginTop: 12}} href={'https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US&utm_source=LOK'}>
                        <img src={playstore} style={{width: 20, height: 20, marginRight: 10}}/>
                        <div>Download Glip Wallet</div>
                        <img src={shield} style={{width: 20, height: 20, marginLeft: 10}}/>
                    </BlueButton>
                </div>
            </div>                    
        </Desktop>
        </>
    );
}

